import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const EditIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M11.6095 2.0572C11.0888 1.5365 10.2446 1.5365 9.7239 2.0572L4.66671 7.11439V9.00001H6.55232L11.6095 3.94281C12.1302 3.42212 12.1302 2.5779 11.6095 2.0572Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33337 4.33334C1.33337 3.59696 1.93033 3.00001 2.66671 3.00001H5.33337C5.70156 3.00001 6.00004 3.29848 6.00004 3.66667C6.00004 4.03486 5.70156 4.33334 5.33337 4.33334H2.66671V11H9.33337V8.33334C9.33337 7.96515 9.63185 7.66667 10 7.66667C10.3682 7.66667 10.6667 7.96515 10.6667 8.33334V11C10.6667 11.7364 10.0698 12.3333 9.33337 12.3333H2.66671C1.93033 12.3333 1.33337 11.7364 1.33337 11V4.33334Z"
      fill="currentColor"
    />
  </svg>
);

export default EditIcon;
